import {
  SingleNamedObject,
  NamedObjectContainer,
  createSvgAndSvgObjects,
  HtmlGraphicObject,
  FixedDimension,
  PercentDimension,
  SvgRectangleArea,
  getHtmlOffset
} from "../../web-graphics";
import { MeasurerLine } from "./measurer-line";

export class Measurer extends HtmlGraphicObject {
  constructor(settings) {
    super(settings);
    HtmlGraphicObject.setHtmlObject(
      this.settings,
      createSvgAndSvgObjects(
        "svg",
        ["x", `${this.settings.htmlObject.locationInPixels.x}px`],
        ["y", `${this.settings.htmlObject.locationInPixels.y}px`],
        ["min-width", `${this.settings.htmlObject.sizeInPixels.width}px`],
        ["width", `${this.settings.htmlObject.sizeInPixels.width}px`],
        ["height", `${this.settings.htmlObject.sizeInPixels.height}px`],
        ["style", `margin: 0px; position: absolute;`]
      )
    );

    this.backgroundRectangle = createSvgAndSvgObjects(
      "rect",
      ["x", `0px`],
      ["y", `0px`],
      ["width", `${this.settings.sizeInPixels.width}`],
      ["height", `${this.settings.sizeInPixels.height}`],
      ["fill", "transparent"],
      ["stroke", "transparent"],
      ["style", `margin: 0px; position: absolute;`]
    );
    this.settings.htmlObject.ref.appendChild(this.backgroundRectangle);
    this.htmlParentOffset = getHtmlOffset(this.settings.htmlObject.parent.ref);

    this.isLeftLineFocused = false;
    this.isRightLineFocused = false;

    this.leftLineX = this.settings.startLeftLinePos;
    this.rightLineX = this.settings.startRightLinePos;

    let leftLineTouchAreaX = this.settings.startLeftLinePos - this.settings.touchLineAreaWidth / 2;
    let leftLineTouchAreaWidth = this.settings.touchLineAreaWidth;
    if (leftLineTouchAreaX < 0) {
      leftLineTouchAreaWidth = this.settings.touchLineAreaWidth + leftLineTouchAreaX;
      leftLineTouchAreaX = 0;
    }
    if (leftLineTouchAreaX >= this.settings.sizeInPixels.width) {
      leftLineTouchAreaWidth = this.settings.touchLineAreaWidth - leftLineTouchAreaX + this.settings.sizeInPixels.width;
      leftLineTouchAreaX = this.settings.sizeInPixels.width - 1;
    }
    let rightLineTouchAreaX = this.settings.startRightLinePos - this.settings.touchLineAreaWidth / 2;
    let rightLineTouchAreaWidth = this.settings.touchLineAreaWidth;
    if (rightLineTouchAreaX < 0) {
      rightLineTouchAreaWidth = this.settings.touchLineAreaWidth + rightLineTouchAreaX;
      rightLineTouchAreaX = 0;
    }
    if (rightLineTouchAreaX >= this.settings.sizeInPixels.width) {
      rightLineTouchAreaWidth = this.settings.touchLineAreaWidth - rightLineTouchAreaX + this.settings.sizeInPixels.width;
      rightLineTouchAreaX = this.settings.sizeInPixels.width - 1;
    }

    this.centerTouchArea = new SvgRectangleArea({
      location: {
        x: new FixedDimension(this.leftLineX),
        y: new FixedDimension(0)
      },
      size: {
        width: new FixedDimension(this.rightLineX - this.leftLineX),
        height: new PercentDimension(1)
      },
      parent: {
        ref: this
      },
      htmlObject: {
        parent: {
          ref: this.settings.htmlObject.ref
        },
        graphicParent: this
      }
    });
    this.centerTouchArea.settings.htmlObject.ref.setAttribute("cursor", "move");
    this.centerTouchArea.setBackgroundFillColor(this.settings.intermediateAreaColor);

    this.leftLineTouchArea = new SvgRectangleArea({
      location: {
        x: new FixedDimension(leftLineTouchAreaX),
        y: new FixedDimension(0)
      },
      size: {
        width: new FixedDimension(leftLineTouchAreaWidth),
        height: new PercentDimension(1)
      },
      parent: {
        ref: this
      },
      htmlObject: {
        parent: {
          ref: this.settings.htmlObject.ref
        },
        graphicParent: this
      }
    });
    this.leftLineTouchArea.settings.htmlObject.ref.setAttribute("cursor", "e-resize");

    this.rightLineTouchArea = new SvgRectangleArea({
      location: {
        x: new FixedDimension(rightLineTouchAreaX),
        y: new FixedDimension(0)
      },
      size: {
        width: new FixedDimension(rightLineTouchAreaWidth),
        height: new PercentDimension(1)
      },
      parent: {
        ref: this
      },
      htmlObject: {
        parent: {
          ref: this.settings.htmlObject.ref
        },
        graphicParent: this
      }
    });
    this.rightLineTouchArea.settings.htmlObject.ref.setAttribute("cursor", "e-resize");

    this.leftLine = new MeasurerLine({
      location: {
        x: new FixedDimension(this.settings.startLeftLinePos),
        y: new FixedDimension(0)
      },
      size: {
        width: new FixedDimension(1),
        height: new PercentDimension(1)
      },
      parent: {
        ref: this
      },
      htmlObject: {
        parent: {
          ref: this.settings.htmlObject.ref
        },
        graphicParent: this
      }
    });
    this.leftLine.setBackgroundFillColor(this.settings.leftLineColor);

    this.rightLine = new MeasurerLine({
      location: {
        x: new FixedDimension(this.settings.startRightLinePos),
        y: new FixedDimension(0)
      },
      size: {
        width: new FixedDimension(1),
        height: new PercentDimension(1)
      },
      parent: {
        ref: this
      },
      htmlObject: {
        parent: {
          ref: this.settings.htmlObject.ref
        },
        graphicParent: this
      }
    });
    this.rightLine.setBackgroundFillColor(this.settings.rightLineColor);

    this.childItemsContainer = new NamedObjectContainer("Items");
    this.childItemsContainer.add(new SingleNamedObject("CenterTouchArea", this.centerTouchArea));
    this.childItemsContainer.add(new SingleNamedObject("LeftLineTouchArea", this.leftLineTouchArea));
    this.childItemsContainer.add(new SingleNamedObject("RightLineTouchArea", this.rightLineTouchArea));
    this.childItemsContainer.add(new SingleNamedObject("LeftLine", this.leftLine));
    this.childItemsContainer.add(new SingleNamedObject("RightLine", this.rightLine));

    this.isLeftLineDragging = false;
    this.isRightLineDragging = false;
    this.spaceBetweenLines = this.settings.startRightLinePos - this.settings.startLeftLinePos;

    this.leftLineTouchArea.addEventListener(
      "mousedown",
      function () {
        this.isLeftLineDragging = true;
      }.bind(this)
    );
    this.leftLineTouchArea.addEventListener("click", event => {
      event.stopPropagation();
      this.isLeftLineDragging = false;
      this.isRightLineDragging = false;
      this.isCenterDragging = false;
      //event.preventDefault();
      if (this.isLeftLineFocused) {
        return false;
      }
      this.isLeftLineFocused = true;
      this.leftLineTouchArea.setBackgroundFillColor(this.settings.focusedAreaColor);
      if (this.isRightLineFocused) {
        this.isRightLineFocused = false;
        this.rightLineTouchArea.setBackgroundFillColor("#00000000");
      }
      return false;
    });
    this.rightLineTouchArea.addEventListener(
      "mousedown",
      function () {
        this.isRightLineDragging = true;
      }.bind(this)
    );
    this.rightLineTouchArea.addEventListener("click", event => {
      event.stopPropagation();
      this.isLeftLineDragging = false;
      this.isRightLineDragging = false;
      this.isCenterDragging = false;
      if (this.isRightLineFocused) {
        return false;
      }
      this.isRightLineFocused = true;
      this.rightLineTouchArea.setBackgroundFillColor(this.settings.focusedAreaColor);
      if (this.isLeftLineFocused) {
        this.isLeftLineFocused = false;
        this.leftLineTouchArea.setBackgroundFillColor("#00000000");
      }
      return false;
    });

    this.settings.htmlObject.ref.addEventListener("mousedown", event => {
      let x = event.pageX - this.htmlParentOffset.left;
      if (this.leftLineX <= x && x <= this.rightLineX) {
        this.centerTouchLastX = x;
        this.isCenterDragging = true;
      }
    });

    this.settings.htmlObject.ref.addEventListener("mousemove", this._onMouseMove.bind(this));

    this.settings.htmlObject.ref.addEventListener("mouseup", event => {
      let x = event.pageX - this.htmlParentOffset.left;
      if (this.isLeftLineDragging) {
        this.leftLineX = x;
        this._moveLine(true, this.leftLineX, "solo");
        this._updateCentralAreaBorders();
        this.updateChildItemsBorders();
        this.isLeftLineDragging = false;
      } else if (this.isRightLineDragging) {
        this.rightLineX = x;
        this._moveLine(false, this.rightLineX, "solo");
        this._updateCentralAreaBorders();
        this.updateChildItemsBorders();
        this.isRightLineDragging = false;
      } else if (this.isCenterDragging) {
        let diff = x - this.centerTouchLastX;
        this.leftLineX += diff;
        if (this.leftLineX < 0) {
          this.leftLineX = 0;
        }
        if (this.leftLineX > this.settings.maxX - this.spaceBetweenLines) {
          this.leftLineX = this.settings.maxX - this.spaceBetweenLines;
        }
        this.rightLineX = this.leftLineX + this.spaceBetweenLines;
        if (this.spaceBetweenLines != this.rightLineX - this.leftLineX) {
          this.leftLineX = this.rightLineX - this.spaceBetweenLines;
        }
        this._moveLine(true, this.leftLineX, "sync");
        this._moveLine(false, this.rightLineX, "sync");
        this._updateCentralAreaBorders();
        this.updateChildItemsBorders();
        this.isCenterDragging = false;
      }
    });

    this.settings.htmlObject.ref.addEventListener("click", event => {
      event.stopPropagation();
      this.isLeftLineDragging = false;
      this.isRightLineDragging = false;
      this.isCenterDragging = false;
      if (this.isLeftLineFocused) {
        this.isLeftLineFocused = false;
        this.leftLineTouchArea.setBackgroundFillColor("#00000000");
      }
      if (this.isRightLineFocused) {
        this.isRightLineFocused = false;
        this.rightLineTouchArea.setBackgroundFillColor("#00000000");
      }
      return false;
    });
  }

  updateHtmlParentOffset() {
    this.htmlParentOffset = getHtmlOffset(this.settings.htmlObject.parent.ref);
  }

  getSpaceBetweenLines() {
    return this.spaceBetweenLines;
  }

  setSpaceBetweenLines(widthInPixels) {
    this.rightLineX = this.leftLineX + widthInPixels;
    if (this.rightLineX >= this.settings.sizeInPixels.width) {
      this.rightLineX = this.settings.sizeInPixels.width - 1;
    }
    this.leftLineX = this.rightLineX - widthInPixels;
    if (this.leftLineX < 0) {
      this.leftLineX = 0;
    }
    this.spaceBetweenLines = this.rightLineX - this.leftLineX;
    this._moveLine(true, this.leftLineX, "sync");
    this._moveLine(false, this.rightLineX, "sync");
    this._updateCentralAreaBorders();
    this.updateChildItemsBorders();
  }

  updateChildItemsBorders() {
    this.childItemsContainer.forEach(item => {
      item.createBorders();
    });
    this.onPositionChanged?.();
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    if (debugSettings.fillHtmlElements) {
      this.setBackgroundFillColor(this.settings.debug.boxFillColor);
    }
    this.childItemsContainer.forEach(item => item.setDebugMode(debugSettings));
  }

  changeMoveMode(mode) {
    this.settings.moveMode = mode; // left, all, right
  }

  addOnClickedFunction(action) {
    this.settings.htmlObject.ref.addEventListener("click", action);
  }

  addItem(name, htmlGraphicChildObject) {
    this.childItemsContainer.add(new SingleNamedObject(name, htmlGraphicChildObject));
  }

  setBackgroundFillColor(color) {
    this.backgroundRectangle.setAttribute("fill", color);
  }

  setBackgroundStrokeColor(color) {
    this.backgroundRectangle.setAttribute("stroke", color);
  }

  createBorders() {
    super.createBorders();
    this.childItemsContainer.forEach(item => {
      item.setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
      item.createBorders();
    });
    this.onPositionChanged?.();
  }

  createHtmlBorders() {
    super.createHtmlBorders();
    this.backgroundRectangle.setAttribute("width", `${this.settings.sizeInPixels.width}px`);
    this.backgroundRectangle.setAttribute("height", `${this.settings.sizeInPixels.height}px`);
    this.settings.htmlObject.ref.setAttribute("x", `${this.settings.htmlObject.absoluteLocation.x}px`);
    this.settings.htmlObject.ref.setAttribute("y", `${this.settings.htmlObject.absoluteLocation.y}px`);
    this.settings.htmlObject.ref.setAttribute("width", `${this.settings.htmlObject.sizeInPixels.width}px`);
    this.settings.htmlObject.ref.setAttribute("height", `${this.settings.htmlObject.sizeInPixels.height}px`);
  }

  moveLine(x, isLeft) {
    this._moveLine(isLeft, x, "solo");
    this._updateCentralAreaBorders();
    this.updateChildItemsBorders();
  }

  moveLinesByLeft(leftLineX) {
    const currDiff = this.rightLineX - this.leftLineX;
    this.moveLines(leftLineX, leftLineX + currDiff);
  }

  moveLines(leftLineX, rightLineX) {
    const newDiff = (rightLineX - leftLineX).toFixed(4);
    const currDiff = (this.rightLineX - this.leftLineX).toFixed(4);
    if (newDiff == currDiff) {
      this._moveLine(true, leftLineX, "sync");
      this._moveLine(false, rightLineX, "sync");
    } else {
      if (leftLineX !== this.leftLineX) {
        this._moveLine(true, leftLineX, "solo");
      }
      if (rightLineX !== this.rightLineX) {
        this._moveLine(false, rightLineX, "solo");
      }
    }
    this._updateCentralAreaBorders();
    this.updateChildItemsBorders();
  }

  _unselectLines() {
    if (this.isLeftLineFocused) {
      this.isLeftLineFocused = false;
      this.leftLineTouchArea.setBackgroundFillColor("#00000000");
    }
    if (this.isRightLineFocused) {
      this.isRightLineFocused = false;
      this.rightLineTouchArea.setBackgroundFillColor("#00000000");
    }
  }

  _onMouseMove(event) {
    //event.preventDefault();
    let x = event.pageX - this.htmlParentOffset.left;
    if (this.isLeftLineDragging) {
      if (x > this.rightLineX - this.settings.minLinesSpace) {
        //x = this.rightLineX - this.settings.minLinesSpace;
        return false;
      }
      this._unselectLines();

      this.leftLine.setLocation(new FixedDimension(x), new FixedDimension(0));
      this._updateCentralTouchAreaBorders(x, this.rightLineX);
      this.childItemsContainer.forEach(item => {
        item.createBorders();
      });
    } else if (this.isRightLineDragging) {
      if (x < this.leftLineX + this.settings.minLinesSpace || x > this.settings.maxX) {
        //x = this.leftLineX + this.settings.minLinesSpace;
        return false;
      }
      this._unselectLines();

      this.rightLine.setLocation(new FixedDimension(x), new FixedDimension(0));
      this._updateCentralTouchAreaBorders(this.leftLineX, x);

      this.childItemsContainer.forEach(item => {
        item.createBorders();
      });
    } else if (this.isCenterDragging) {
      let diff = x - this.centerTouchLastX;
      let leftLineX = this.leftLineX + diff;

      if (leftLineX < 0 || leftLineX > this.settings.maxX - this.spaceBetweenLines) {
        return false;
      }
      this._unselectLines();
      let rightLineX = leftLineX + this.spaceBetweenLines;
      if (this.spaceBetweenLines != rightLineX - leftLineX) {
        leftLineX = rightLineX - this.spaceBetweenLines;
      }
      this.leftLine.setLocation(new FixedDimension(leftLineX), new FixedDimension(0));
      this.rightLine.setLocation(new FixedDimension(rightLineX), new FixedDimension(0));
      this._updateCentralTouchAreaBorders(leftLineX, rightLineX);
      this.childItemsContainer.forEach(item => {
        item.createBorders();
      });
    }
    return false;
  }

  _updateCentralAreaBorders() {
    this._updateCentralTouchAreaBorders(this.leftLineX, this.rightLineX);
  }

  _updateCentralTouchAreaBorders(leftLineX, rightLineX) {
    this.centerTouchArea.setLocation(new FixedDimension(leftLineX), new FixedDimension(0));
    this.centerTouchArea.setSize(new FixedDimension(rightLineX - leftLineX), new PercentDimension(1));
  }

  _moveLine(isLeft, x, selectMode) {
    let movedLine = isLeft ? this.leftLine : this.rightLine;
    let movedLineTouchArea = isLeft ? this.leftLineTouchArea : this.rightLineTouchArea;
    let movedLineX = x;
    if (x > this.settings.maxX) {
      movedLineX = this.settings.maxX;
    }
    if (selectMode == "solo") {
      if (isLeft) {
        if (movedLineX > this.rightLineX - this.settings.minLinesSpace) {
          movedLineX = this.rightLineX - this.settings.minLinesSpace;
        }
        this.leftLineX = movedLineX;
      } else {
        if (movedLineX < this.leftLineX + this.settings.minLinesSpace) {
          movedLineX = this.leftLineX + this.settings.minLinesSpace;
        }
        this.rightLineX = movedLineX;
      }
      this.spaceBetweenLines = this.rightLineX - this.leftLineX;
      this.onSpaceBetweenLinesChanged?.(this.spaceBetweenLines);
    }
    if (isLeft) {
      this.leftLineX = movedLineX;
    } else {
      this.rightLineX = movedLineX;
    }

    let lineTouchAreaX = movedLineX - this.settings.touchLineAreaWidth / 2;
    let lineTouchAreaWidth = this.settings.touchLineAreaWidth;
    if (lineTouchAreaX < 0) {
      lineTouchAreaWidth = this.settings.touchLineAreaWidth / 2;
      lineTouchAreaX = 0;
    }
    if (lineTouchAreaX + this.settings.touchLineAreaWidth > this.settings.sizeInPixels.width) {
      lineTouchAreaWidth = this.settings.sizeInPixels.width + this.settings.touchLineAreaWidth / 2 - movedLineX;
    }

    movedLine.setLocation(new FixedDimension(movedLineX), new FixedDimension(0));
    movedLineTouchArea.setLocation(new FixedDimension(lineTouchAreaX), new FixedDimension(0));
    movedLineTouchArea.setSize(new FixedDimension(lineTouchAreaWidth), new PercentDimension(1));
  }
}
